/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RecordCompletedJourneyRequest} from '@cash-web/protos/squareup/cash/blockuserjourneys/api/v1/service.pb'
import {RecordCompletedJourneyResponse} from '@cash-web/protos/squareup/cash/blockuserjourneys/api/v1/service.pb'


export const recordCompletedJourney = (request:RecordCompletedJourneyRequest, options?: CashRequestOptions) => post<RecordCompletedJourneyRequest, RecordCompletedJourneyResponse>("/cash-app/user-journeys/record-completed-journey", request, {...options, rejectOnError: true })